import axios from 'axios';
import config from '../config';

class AuthService {
  login(user) {
    return axios
      .get(config.API_URL + '/securityusers?select=name&where=loginname+eq+%27'+user.username+'%27', {
        auth: {
            username: user.username,
            password: user.password
        }
      })
      .then(response => {
        if (response.data.name == user.name) {
          const token = `${user.username}:${user.password}`;
          const encodedToken = btoa(token);
          response.data[0].accessToken = encodedToken;
          localStorage.setItem('user', JSON.stringify(response.data));
          console.log('Response:',response.data);
          if (response.data[0].accessToken) {
            console.log('LocalStorage content:',localStorage.getItem('user'));
          }   
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  // register(user) {
  //   return axios.post(API_URL + 'signup', {
  //     username: user.username,
  //     email: user.email,
  //     password: user.password
  //   });
  // }
}

export default new AuthService();